import './pagination.scss';

import { Pagination as AntdPagination, Select } from 'antd';

import { useWindowSize } from '@/shared/hooks/useWindowSize';

const PAGE_SIZE_OPTIONS = [
  { label: 'Показать 10', value: 10 },
  { label: 'Показать 20', value: 20 },
  { label: 'Показать 50', value: 50 }
];

interface IProps {
  className?: string;
  currentPage: number;
  itemsPerPage: number;
  total: number;
  handlePageChange: (pagination: { page?: number; pageSize?: number }) => void;
  showLimitSelector?: boolean;
}

const Pagination: React.FC<IProps> = ({
  className = '',
  currentPage,
  itemsPerPage,
  total,
  handlePageChange,
  showLimitSelector = true
}) => {
  const [windowWidth] = useWindowSize();

  return (
    <div className={`pagination ${className}`}>
      <AntdPagination
        current={currentPage}
        pageSize={itemsPerPage}
        total={total}
        showSizeChanger={false}
        simple={windowWidth <= 560}
        showLessItems
        onChange={(page) => {
          handlePageChange({ page });
        }}
      />

      {showLimitSelector && (
        <div className="pagination__limit-container">
          <span className="pagination__limit-text">
            {1 + (currentPage - 1) * itemsPerPage}-{currentPage * itemsPerPage}{' '}
            из {total} заявок
          </span>
          <Select
            options={PAGE_SIZE_OPTIONS}
            onChange={(value) => {
              handlePageChange({ pageSize: Number(value) });
            }}
            value={`Показать ${itemsPerPage}`}
          />
        </div>
      )}
    </div>
  );
};

export default Pagination;
